// extracted by mini-css-extract-plugin
module.exports = {"page-discover-podcasts--section":"pages-PageDiscoverPodcasts-PageDiscoverPodcasts_page-discover-podcasts--section"};